import { createFileRoute, Outlet } from '@tanstack/react-router';
import { Brain } from 'lucide-react';

export const Route = createFileRoute('/admin-console/platform-content/ai-training')({
    staticData: {
        // P2.1: AI training data is gated by admin_ai:read because the underlying
        // tRPC routes use adminAiProcedure / adminAiQueryProcedure and the page
        // calls useAdminModulePermissions('ai'). Aligning the route permission
        // here ensures the nav and the API agree on visibility.
        permissions: ['admin_ai:read'],
        breadcrumb: {
            title: 'AI training',
            inactive: true,
        },
        ui: {
            icon: Brain,
            menuDescription: 'Curated training data for AI classification and detection',
        },
    },
    component: Outlet,
});
